import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const PerdayRecord = () => {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BACKEND_LOCAL_API
      : process.env.REACT_APP_BACKEND_LIVE_API;

  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchPerDayRecord = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${baseUrl}per-day/record`,
        {
          params: {
            startDateTime: startDate || undefined,
            endDateTime: endDate || undefined,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRecords(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPerDayRecord();
  }, []);

  // merge all per-day data in one object by date
  const mergedByDate = {};

  records.forEach((block) => {
    Object.keys(block).forEach((type) => {
      block[type].forEach((row) => {
        const date = row._id.date;
        if (!mergedByDate[date]) {
          mergedByDate[date] = {
            date,
            deposit: 0,
            withdraw: 0,
            bonus: 0,
            penalty: 0,
            transfer: 0,
            exchange: 0,
            commission: 0,
            referral: 0,
          };
        }
        mergedByDate[date][type === "referalEarnings" ? "referral" : type] =
          row.total;
      });
    });
  });

  const finalData = Object.values(mergedByDate).sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <div className="container mt-4">
      <Card>
        <Card.Body>
          <h4 className="mb-3">📊 Per Day Financial Report</h4>

          {/* Date Filter */}
          <div className="row mb-3">
            <div className="col-md-4">
              <input
                type="datetime-local"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <input
                type="datetime-local"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <button
                className="btn btn-primary w-100"
                onClick={fetchPerDayRecord}
              >
                Fetch
              </button>
            </div>
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-light">
                  <tr>
                    <th>Date</th>
                    <th>Deposit</th>
                    <th>Withdraw</th>
                    <th>Bonus</th>
                    <th>Penalty</th>
                    
                    <th>Commission</th>
                    <th>Referral</th>
                  </tr>
                </thead>
                <tbody>
                  {finalData.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    finalData.map((row, i) => (
                      <tr key={i}>
                        <td>{row.date}</td>
                        <td>{row.deposit}</td>
                        <td>{row.withdraw}</td>
                        <td>{row.bonus}</td>
                        <td>{row.penalty}</td>
                       
                        <td>{row.commission}</td>
                        <td>{row.referral}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PerdayRecord;
